export default __webpack_public_path__ + "static/media/Barlow-Regular.52700744.otf";